import { c as _c } from "react/compiler-runtime";
import { useDate, useDestination, useHistory, usePassengerCount, useSubmit, useValidation } from "@website/accommodation-ui/villa-search/villa-search-panel/hooks";
import { PassengerCountInitialValuesType, VillaSearchPanelPropertiesType } from "@website/accommodation-ui/villa-search/villa-search-panel/villa-search-panel.types";
import { VillaSearchPassengerCount } from "@website/accommodation-ui/villa-search/villa-search-passenger-count";
import { MaterialIcon } from "@website/icons/material";
import { AutoComplete } from "@website/ui/auto-complete";
import { Button } from "@website/ui/button";
import { Datepicker } from "@website/ui/datepicker";
import { FC, useEffect } from "react";
export const VillaSearchPanel: FC<VillaSearchPanelPropertiesType> = properties => {
  const $ = _c(88);
  const {
    size,
    searchType,
    initialCityData,
    onClose,
    passengerCountInitialValues,
    datePickerInitialValues,
    handleSearchSubmit,
    searchSuggestion,
    searchAutocompleteFetcher,
    submitOnDestinationSelect
  } = properties;
  const t0 = passengerCountInitialValues as PassengerCountInitialValuesType;
  let t1;
  if ($[0] !== searchType || $[1] !== t0) {
    t1 = {
      initialValues: t0,
      searchType
    };
    $[0] = searchType;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    passengerCount,
    onSubmitPassengerCount,
    passengerCountList,
    passengerCountTitle,
    passengerCountResult,
    passengerCountValidation
  } = usePassengerCount(t1);
  const t2 = initialCityData?.title;
  let t3;
  if ($[3] !== searchAutocompleteFetcher || $[4] !== searchSuggestion || $[5] !== t2) {
    t3 = {
      cityTitleInitialValues: t2,
      searchSuggestion,
      searchAutocompleteFetcher
    };
    $[3] = searchAutocompleteFetcher;
    $[4] = searchSuggestion;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const {
    selectedDestinationItem,
    selectedDestinationText,
    destinationQuery,
    onChangeDestination,
    onChangeDestinationQuery,
    onSelectDestination,
    destinationLoading,
    destinationListNormalized,
    DestinationNoResult
  } = useDestination(t3);
  const {
    date,
    onChangeDate
  } = useDate(datePickerInitialValues);
  const {
    historyListNormalized,
    addToHistory,
    onSelectHistory
  } = useHistory(onChangeDestination, submitOnDestinationSelect);
  let t4;
  if ($[7] !== date || $[8] !== initialCityData || $[9] !== searchType || $[10] !== selectedDestinationItem) {
    t4 = {
      acceptEmpty: true,
      selectedDestinationItem,
      date,
      initialDestinationItem: initialCityData,
      searchType
    };
    $[7] = date;
    $[8] = initialCityData;
    $[9] = searchType;
    $[10] = selectedDestinationItem;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const {
    destinationError,
    dateError,
    submitValidationCheck
  } = useValidation(t4);
  const {
    onSubmitClick,
    submitLoading
  } = useSubmit(selectedDestinationItem, date, passengerCount, addToHistory, submitValidationCheck, handleSearchSubmit, initialCityData);
  let t5;
  let t6;
  if ($[12] !== onSubmitClick || $[13] !== selectedDestinationItem || $[14] !== submitOnDestinationSelect) {
    t5 = () => {
      if (submitOnDestinationSelect && selectedDestinationItem) {
        onSubmitClick();
      }
    };
    t6 = [onSubmitClick, selectedDestinationItem, submitOnDestinationSelect];
    $[12] = onSubmitClick;
    $[13] = selectedDestinationItem;
    $[14] = submitOnDestinationSelect;
    $[15] = t5;
    $[16] = t6;
  } else {
    t5 = $[15];
    t6 = $[16];
  }
  useEffect(t5, t6);
  const t7 = `${searchType === "villa" ? "gap-8" : "gap-6"} relative mb-4 flex h-full flex-col lg:mb-0 lg:h-auto`;
  const t8 = searchType === "villa" ? "\u062A\u0639\u06CC\u06CC\u0646 \u0628\u0627\u0632\u0647 \u0627\u0642\u0627\u0645\u062A \u0648 \u0645\u0633\u0627\u0641\u0631\u0627\u0646" : "\u0627\u0642\u0627\u0645\u062A\u06AF\u0627\u0647";
  let t9;
  if ($[17] !== t8) {
    t9 = <h3 className="text-headline-6 lg:hidden">{t8}</h3>;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== onSubmitPassengerCount || $[20] !== passengerCountList || $[21] !== passengerCountResult || $[22] !== passengerCountTitle || $[23] !== passengerCountValidation || $[24] !== searchType) {
    t10 = (searchType === "city" || searchType === "category") && <div className="flex h-8 flex-row justify-between gap-2"><VillaSearchPassengerCount list={passengerCountList} onSubmit={onSubmitPassengerCount} result={passengerCountResult} searchType={searchType} size="dense" title={passengerCountTitle} validation={passengerCountValidation} /></div>;
    $[19] = onSubmitPassengerCount;
    $[20] = passengerCountList;
    $[21] = passengerCountResult;
    $[22] = passengerCountTitle;
    $[23] = passengerCountValidation;
    $[24] = searchType;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== onSubmitPassengerCount || $[27] !== passengerCountList || $[28] !== passengerCountResult || $[29] !== passengerCountValidation || $[30] !== searchType) {
    t11 = searchType === "home" && <div className="flex h-8 flex-row justify-between gap-2"><VillaSearchPassengerCount list={passengerCountList} onSubmit={onSubmitPassengerCount} result={passengerCountResult} searchType={searchType} title={"\u062A\u0639\u062F\u0627\u062F \u0645\u0633\u0627\u0641\u0631"} validation={passengerCountValidation} /></div>;
    $[26] = onSubmitPassengerCount;
    $[27] = passengerCountList;
    $[28] = passengerCountResult;
    $[29] = passengerCountValidation;
    $[30] = searchType;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  const t12 = `flex flex-col gap-4 xl:flex-row ${searchType === "villa" ? "w-full" : ""}`;
  const t13 = `flex flex-col gap-4 lg:flex-row ${searchType === "city" ? "flex-1" : "w-full lg:items-center"}`;
  let t14;
  if ($[32] !== DestinationNoResult || $[33] !== destinationError || $[34] !== destinationListNormalized || $[35] !== destinationLoading || $[36] !== destinationQuery || $[37] !== historyListNormalized || $[38] !== onChangeDestinationQuery || $[39] !== onSelectDestination || $[40] !== onSelectHistory || $[41] !== searchType || $[42] !== selectedDestinationText || $[43] !== size) {
    t14 = searchType !== "villa" && <div className={`flex-[3] ${searchType === "category" ? "pointer-events-none opacity-60" : ""}`}><AutoComplete error={destinationError} fullWidth={true} parts={[{
        label: "\u0634\u0647\u0631 \u06CC\u0627 \u0627\u0642\u0627\u0645\u062A\u06AF\u0627\u0647 \u0645\u0642\u0635\u062F",
        list: DestinationNoResult ? [] : destinationListNormalized,
        historyList: !DestinationNoResult && !destinationLoading ? historyListNormalized : [],
        historyTitle: "\u062C\u0633\u062A\u062C\u0648 \u0647\u0627\u06CC \u0627\u062E\u06CC\u0631",
        text: selectedDestinationText || "",
        onSelect: onSelectDestination,
        onSelectHistory,
        onChangeQuery: onChangeDestinationQuery,
        query: destinationQuery,
        loading: destinationLoading,
        NoResult: DestinationNoResult
      }]} size={size} /></div>;
    $[32] = DestinationNoResult;
    $[33] = destinationError;
    $[34] = destinationListNormalized;
    $[35] = destinationLoading;
    $[36] = destinationQuery;
    $[37] = historyListNormalized;
    $[38] = onChangeDestinationQuery;
    $[39] = onSelectDestination;
    $[40] = onSelectHistory;
    $[41] = searchType;
    $[42] = selectedDestinationText;
    $[43] = size;
    $[44] = t14;
  } else {
    t14 = $[44];
  }
  const t15 = `${searchType === "villa" ? "flex-auto lg:max-w-[312px]" : "flex-[2]"}`;
  const t16 = dateError.length > 0;
  const t17 = searchType === "villa" ? "0px" : "-16px";
  const t18 = searchType === "villa" ? "42px" : "-16px";
  const t19 = searchType === "villa" ? "start" : "end";
  const t20 = searchType === "villa" ? "dense" : "default";
  let t21;
  if ($[45] !== date) {
    t21 = date ?? [];
    $[45] = date;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  let t22;
  if ($[47] !== dateError || $[48] !== onChangeDate || $[49] !== t16 || $[50] !== t17 || $[51] !== t18 || $[52] !== t19 || $[53] !== t20 || $[54] !== t21) {
    t22 = <Datepicker acceptEmpty={true} error={t16} fromTitle={"\u062A\u0627\u0631\u06CC\u062E \u0648\u0631\u0648\u062F"} fullWidth={true} gapHorizontal={t17} gapVertical={t18} helperText={dateError} mode="range" onChange={onChangeDate} position={t19} size={t20} toTitle={"\u062A\u0627\u0631\u06CC\u062E \u062E\u0631\u0648\u062C"} value={t21} />;
    $[47] = dateError;
    $[48] = onChangeDate;
    $[49] = t16;
    $[50] = t17;
    $[51] = t18;
    $[52] = t19;
    $[53] = t20;
    $[54] = t21;
    $[55] = t22;
  } else {
    t22 = $[55];
  }
  let t23;
  if ($[56] !== t15 || $[57] !== t22) {
    t23 = <div className={t15}>{t22}</div>;
    $[56] = t15;
    $[57] = t22;
    $[58] = t23;
  } else {
    t23 = $[58];
  }
  const t24 = `${searchType === "home" ? "static" : "absolute"} bottom-0 w-full lg:relative lg:w-[134px]`;
  const t25 = searchType === "villa" ? "secondary" : "primary";
  const t26 = searchType === "villa" ? "medium" : "x-large";
  let t27;
  if ($[59] !== onSubmitClick || $[60] !== submitLoading || $[61] !== t25 || $[62] !== t26) {
    t27 = <Button color={t25} fullWidth={true} loading={submitLoading} onClick={onSubmitClick} size={t26}>بروزرسانی جستجو</Button>;
    $[59] = onSubmitClick;
    $[60] = submitLoading;
    $[61] = t25;
    $[62] = t26;
    $[63] = t27;
  } else {
    t27 = $[63];
  }
  let t28;
  if ($[64] !== t24 || $[65] !== t27) {
    t28 = <div className={t24}>{t27}</div>;
    $[64] = t24;
    $[65] = t27;
    $[66] = t28;
  } else {
    t28 = $[66];
  }
  const t29 = `absolute left-0 top-0 mr-auto hidden text-center ltr:ml-auto ${searchType === "villa" ? "xl:mt-0" : ""} ${searchType === "home" ? "lg:hidden" : "lg:block"}`;
  let t30;
  if ($[67] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <MaterialIcon name="close" />;
    $[67] = t30;
  } else {
    t30 = $[67];
  }
  let t31;
  if ($[68] !== onClose) {
    t31 = <Button StartIcon={t30} color="neutral" onClick={onClose} size="small" variant="text" />;
    $[68] = onClose;
    $[69] = t31;
  } else {
    t31 = $[69];
  }
  let t32;
  if ($[70] !== t29 || $[71] !== t31) {
    t32 = <div className={t29}>{t31}</div>;
    $[70] = t29;
    $[71] = t31;
    $[72] = t32;
  } else {
    t32 = $[72];
  }
  let t33;
  if ($[73] !== t13 || $[74] !== t14 || $[75] !== t23 || $[76] !== t28 || $[77] !== t32) {
    t33 = <div className={t13}>{t14}{t23}{t28}{t32}</div>;
    $[73] = t13;
    $[74] = t14;
    $[75] = t23;
    $[76] = t28;
    $[77] = t32;
    $[78] = t33;
  } else {
    t33 = $[78];
  }
  let t34;
  if ($[79] !== t12 || $[80] !== t33) {
    t34 = <div className={t12}>{t33}</div>;
    $[79] = t12;
    $[80] = t33;
    $[81] = t34;
  } else {
    t34 = $[81];
  }
  let t35;
  if ($[82] !== t10 || $[83] !== t11 || $[84] !== t34 || $[85] !== t7 || $[86] !== t9) {
    t35 = <div className={t7}>{t9}{t10}{t11}{t34}</div>;
    $[82] = t10;
    $[83] = t11;
    $[84] = t34;
    $[85] = t7;
    $[86] = t9;
    $[87] = t35;
  } else {
    t35 = $[87];
  }
  return t35;
};